export default "__VITE_ASSET__Hem_$2ne__"